/**
 * Descrições dos códigos da venda, compartilhadas entre o grid de vendas e o cabeçalho
 * de contexto dos grids de detalhe (itens e insumos).
 */

export const describeSituacao = (situacao) => {
    if (situacao) {
        switch (situacao) {
            case 'V':
                return 'Venda'
            case 'C':
                return 'Cancelada'
            case 'T':
                return 'Cortesia'
            case 'D':
                return 'Devolvida'
            case 'I':
                return 'Consumo interno'
            case 'P':
                return 'Desperdicio'
        }
    }
    return 'Venda'
}

export const describeTipo = (tipo) => {
    if (tipo) {
        switch (tipo) {
            case 'I':
                return 'Consumo interno'
            case 'P':
                return 'Desperdício'
            case 'D':
                return 'Venda'
            case 'T':
                return 'Cortesia'
        }
    }
    return 'Venda'
}

export const describeAtendimento = (atendimento) => {
    if (atendimento) {
        switch (atendimento) {
            case 'D':
                return 'Delivery'
            case 'B':
                return 'Balcão'
        }
    }
    return 'Mesa'
}

// Enquanto carrega, o MaterialReactTable renderiza linhas de placeholder com todos os
// campos nulos. Sem esta guarda, todas elas gerariam a mesma identidade e o React
// duplicaria/omitiria linhas por causa das keys repetidas.
const preenchido = valor => valor !== null && valor !== undefined && valor !== ''

/**
 * Identifica a venda de forma estável entre empresas: o número da venda só é único
 * dentro de uma empresa. Devolve null quando a linha não tem as chaves.
 */
export const identificarVenda = venda => venda && preenchido(venda.idEmpresa) && preenchido(venda.Seq)
    ? `${venda.idEmpresa}-${venda.Seq}`
    : null

/**
 * Identifica o item dentro da venda. Seq é a sequência do item (única por empresa) e
 * Item é o ordinal dentro da venda. Devolve null quando a linha não tem as chaves.
 */
export const identificarItem = item => item && preenchido(item.Seq) && preenchido(item.Item)
    ? `${item.Seq}-${item.Item}`
    : null
